let searchBtn = document.querySelector(".search-btn")
  let searchBox = document.querySelector(".serach-overly")
  let closeBtn = document.querySelector(".seach-close")

  searchBtn.onclick = () =>{
    searchBox.classList.add("active")
    document.body.classList.add('scrollOff');
    $('.main-search input[name=q]').focus();
  }
  
  closeBtn.onclick = () =>{
    searchBox.classList.remove("active")
    document.body.classList.remove('scrollOff');
}
        

